import { indexBy } from 'ramda'
import React from 'react'

export const ParkingFeeRateTypeEnum = {
  // 計次
  Count: 2,
  // 計時
  Time: 3,
  // 累進
  Progress: 4,
}

export const useParkingFeeRateTypeEnum = (options?: {
  supportFreeRate?: boolean
}) => {
  const { supportFreeRate = false } = options || {}
  const [data, byId] = React.useMemo(() => {
    const data = [
      {
        id: 2,
        label: '計次',
      },
      {
        id: 3,
        label: '計時',
      },
      {
        id: 4,
        label: '累進',
      },
    ]
    if (supportFreeRate) {
      data.unshift({
        id: 1,
        label: '免費',
      })
    }

    const byId = indexBy(x => x.id, data)

    return [data, byId]
  }, [supportFreeRate])

  return {
    data,
    byId,
  }
}

export const useParkingFeeStatusEnum = () => {
  const statusEnum = {
    PENDING: 0,
    PROCESSING: 1,
    FINISHED: 2,
  }

  const data = [
    {
      id: 0,
      label: '尚未開始',
    },
    {
      id: 1,
      label: '進行中',
    },
    {
      id: 2,
      label: '已結束',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}
